import {computed, _, Fragment, observer, React, Popover2} from '@api'
import {Icon, Menu, MenuDivider, MenuItem} from '@blueprintjs/core'
import {AssortmentHeroCardStore, BuilderCardStore, IContextualHoverItemStore, useAssortmentHeroCardStore} from '@modules/catalog'
import {ContextMenuItem, IContextMenuItems} from '@modules/contextMenus'
import {VipLocalStore} from '@modules/VipLocalStore'
import * as css from './AssortmentHeroCardTitle.css'
import {PrimaryIconButton} from 'centric-ui-components'
import {UNASSIGNED} from '@design-board'

export class AssortmentHeroTitleCardStore extends VipLocalStore implements IContextualHoverItemStore, IContextMenuItems {
  constructor(public hero: AssortmentHeroCardStore) {
    super(hero.stores)
  }

  @computed get title() {
    const {catalog: {settings}, hero: {dataMap: {title}, data, strings, selectedHeroItem, isReallySubdivided}} = this
    if (!data) return null

    const {key, items, combined} = data
    let label = _.isEmpty(items) || !selectedHeroItem ? key : (_.get(selectedHeroItem, title.field) ?? strings.emptyLabel)
    if (!isReallySubdivided && !_.isEmpty(combined)) {
      if (settings.assortment?.hero?.removeCombinedCommonWords) {
        // Combine things like ['Open Nightstand', 'Closed Nightstand'] into 'Open & Closed Nightstand'
        const words = label.split(' '),
          othersSplit = combined.map(c => (c.key?.toString() ?? UNASSIGNED).split(' ')),
          commonEndingWords = []

        while (words.length > 1) {
          const lastWord = _.last(words)
          if (othersSplit.every(v => _.last(v) === lastWord)) {
            commonEndingWords.splice(0, 0, lastWord)
            words.splice(words.length - 1, 1)
            othersSplit.forEach(v => v.splice(v.length - 1))
          } else {
            break
          }
        }

        label = words.join(' ')
        label = [label, ...othersSplit.map(v => v.join(' '))].join(' & ')
        label = [label, ...commonEndingWords].join(' ')
      } else {
        combined.forEach(({key}) => label += ` & ${key}`)
      }
    }

    return label
  }

  /**
   * The raw skeleton of the hero box - shape master in RH
   * @param e
   */
  onDoubleClick = (e: React.MouseEvent) => {
    e.stopPropagation()

    const {
      stores: {ui, flexLayoutCatalogRoot: {tab}, sidebar: {right: {selectPathItem, selectedPathIndex}}},
      hero: {assortment, detailsPathSkeleton, associatedWorkspaceRealized, catalogFieldSkeleton}
    } = this

    // console.log(`onDoubleClick`, {associatedWorkspaceRealized, detailsPathSkeleton})

    !_.isEmpty(detailsPathSkeleton) && associatedWorkspaceRealized && selectPathItem(selectedPathIndex + 1, _.last(detailsPathSkeleton))

    setTimeout(() => assortment.scrollIntoView(), ui.settings.flexLayout.scrollIntoViewDelayAfterNewChildTab)
  }

  @computed get titleHoverItemEvents() {
    return this.hero.cardStore.card.hoverItemEventsFor(this)
  }

  @computed get contextMenuItems() { return this.hero.contextMenuItems}

  @computed get hoverId() { return this.title}

  matchesHoverItem = (card: BuilderCardStore) => {
    if (!this.hero?.cardStore?.config?.item) return false

    let {hero: {cardStore: {config: {item}}, dataMap: {title: titleConfig}}, title} = this, {data, props: {nested}} = card

    let titleField = !nested ? titleConfig.field.replace('__parent.', '') : titleConfig.field
    return _.get(data, titleField) === title
  }
}

export const HeroCardTitle = observer<{}, HTMLDivElement>(function HeroCardTitle({}, ref) {
  const {
    isReallySubdivided, toggleSubdivide, index, toggleFullWidth, onUncombineHero, onUncombineHeroKey, flipCombinedOrientation, combinedSettingsEntry, dataKey, data: {combined},
    titleStore: {title, onDoubleClick, titleHoverItemEvents}, onDragStart, combinedCount,
    cardStore: {foreignKeyFieldSkeleton, overrides: {fullWidth, orders}}, dragDrop: {isDragging},
    assortmentSettings: {heroCards: {}}, isSortOverridden, toggleCustomSort,
    catalog
  } = useAssortmentHeroCardStore()

  return (<Fragment>
    {/*<Tooltip*/}
    {/*  placement='bottom'*/}
    {/*  title={foreignKeyFieldSkeleton ? catalog.labelForField(foreignKeyFieldSkeleton) : ''}*/}
    {/*>*/}
    <div className={css.root} ref={ref}>
      <Popover2
        interactionKind='hover'
        placement='bottom'
        disabled={isDragging || (index === 0 && combinedCount === 0)}
        className={css.popover}
        popoverClassName={css.heroCardMenuPopover}
        content={
          <Menu className={css.heroCardMenu}>
            {false && isSortOverridden && <ContextMenuItem
				active={isSortOverridden}
				shouldDismissPopover
				text={`Remove Custom Sort`} onClick={toggleCustomSort}/>}
            {false && <MenuDivider className={css.menuTitlebar} title={
              <Fragment>
                <label>Combined {foreignKeyFieldSkeleton ? catalog.labelForField(foreignKeyFieldSkeleton, 'Item', 'plural') : 'Items'} ({1 + combined.length})</label>
                <div className={css.icons}>
                  <PrimaryIconButton icon={combinedSettingsEntry?.orientation === 'horizontal' ? 'swap-horizontal' : 'swap-vertical'}
                                     tooltipPosition='top'
                                     tooltipStyle='mui'
                                     tooltip={`${_.capitalize(combinedSettingsEntry.orientation ?? 'horizontal')} Orientation`}
                                     onClick={flipCombinedOrientation}/>
                </div>
              </Fragment>}/>}
            {index != 0 && <ContextMenuItem icon={'arrows-horizontal'}
                                            text={`Full Width`}
                                            active={fullWidth != null && fullWidth[dataKey] === true}
                                            onClick={toggleFullWidth}/>}

            {combinedCount > 0 &&
			 <Fragment>
				 <ContextMenuItem
					 icon={combinedSettingsEntry?.orientation === 'horizontal' ? 'swap-vertical' : 'swap-horizontal'}
                   //text={`${_.capitalize(combinedSettingsEntry.orientation ?? 'horizontal')} Orientation`}
					 text='Flip Combined Orientation'
					 onClick={flipCombinedOrientation}/>

				 <ContextMenuItem icon={'split-columns'}
				                  text={`Subdivide Cards`}
				                  shouldDismissPopover
				                  active={isReallySubdivided === true}
				                  onClick={toggleSubdivide}/>


				 <MenuDivider/>
				 <ContextMenuItem icon={'ungroup-objects'}
				                  shouldDismissPopover
				                  text={`Uncombine Item(s)`}
				                  onClick={onUncombineHero}>
					 <ContextMenuItem icon={'trash'}
					                  shouldDismissPopover
					                  text='Uncombine All'
					                  onClick={onUncombineHero}/>
					 <MenuDivider title='Remove Entry'/>
                   {combinedSettingsEntry.keys.map(key => <ContextMenuItem icon='blank' text={key} shouldDismissPopover={false} key={key} onClick={() => onUncombineHeroKey(key)}/>)}
				 </ContextMenuItem>

               {/*<ContextMenuItem text={dataKey}>*/}
               {/*  <ContextMenuItem icon='trash' text='Remove' onClick={onUncombineHero(dataKey)}/>*/}
               {/*</ContextMenuItem>*/}
               {/*{combined.map(({key}) => (<ContextMenuItem text={key} key={key}>*/}
               {/*  <ContextMenuItem icon='trash' text='Remove' onClick={onUncombineHero(key)}/>*/}
               {/*</ContextMenuItem>))}*/}

			 </Fragment>}
          </Menu>
        }>
        <div className={css.title}
          // draggable
          // onDragStart={onDragStart}
          //onDoubleClick={onDoubleClick}  // This is annoying vs toggling the expansion state of the whole card.  We can show a details button as we do for regulard cards in the future (or they can use the context menu)
             {...titleHoverItemEvents}
        >
          <div className={css.titleInternal}>
            {<Fragment>

              <span className={css.titleText} onDoubleClick={onDoubleClick}>{title}</span>

              {false && <div className={css.hoverButtons}>
				  <PrimaryIconButton icon={combinedSettingsEntry?.orientation === 'horizontal' ? 'swap-horizontal' : 'swap-vertical'}
				                     tooltipPosition='top'
				                     tooltipStyle='mui'
				                     tooltip={`${_.capitalize(combinedSettingsEntry.orientation ?? 'horizontal')} Orientation`}
				                     onClick={flipCombinedOrientation}/>
				  <PrimaryIconButton icon={'ungroup-objects'}
				                     tooltipPosition='top'
				                     tooltipStyle='mui'
				                     tooltip={`Uncombine Cards`}
				                     onClick={onUncombineHero}/>
			  </div>}
            </Fragment>}
          </div>
        </div>
      </Popover2>
    </div>
    {/*</Tooltip>*/}
  </Fragment>)
}, {forwardRef: true})

/*

        {false &&
		 <div className={css.hoverButtons}>
			 <PrimaryIconButton
				 draggable
				 disableRipple
				 tooltip='Drag To Reorder/Combine'
				 icon='drag-handle-horizontal'
				 onDragStart={onDragStart}/>
		 </div>}
 */


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/HeroCards/AssortmentHeroCardTitle.tsx